import type {FlexSuiteHeroProps} from './types'
import {FlexSuiteHeroDefault} from './FlexSuiteHeroDefault'
import {FlexSuiteHeroStacked} from './FlexSuiteHeroStacked'

export function FlexSuiteHero(props: FlexSuiteHeroProps) {
  const {heroVariant} = props

  switch (heroVariant) {
    case 'Stacked':
      return <FlexSuiteHeroStacked fields={props} />
    default:
      return <FlexSuiteHeroDefault fields={props} />
  }
}
